import { useQuery } from "@tanstack/react-query";

import { TGetProject, TProject } from "../../../models";
import { getProject } from "../../../services/projects";

type TResponseReadProject = {
    projects: TProject[];
    total_entries: number;
    total_pages: number;
};

export function useReadProject({
    params,
    start,
    onFinish,
}: {
    start?: boolean;
    params: TGetProject;
    onFinish?: (value: TResponseReadProject) => void;
}) {
    return useQuery<TResponseReadProject, unknown, TResponseReadProject>({
        enabled: !!start,
        queryKey: [`readCategory`],
        queryFn: () => getProject({ ...params }),
        refetchOnMount: "always",
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        onSuccess: onFinish,
    });
}
